(function(){
  if (window.__fogProductInit) return;
  window.__fogProductInit = true;

  function rootUrl(path){
    const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    return `${root}${path}`.replace(/\/\/+/g,'/');
  }

  async function resolveVariantId(variant){
    let id=String((variant&&variant.value)||'').trim();
    if (/^\d+$/.test(id)) return id;

    const match=window.location.pathname.match(/\/products\/([^/?#]+)/);
    if(!match) throw new Error('Please select an available product option.');
    const handle=decodeURIComponent(match[1]);
    const selectedText=variant&&variant.tagName==='SELECT'&&variant.selectedOptions[0]
      ? String(variant.selectedOptions[0].textContent||'').replace(/\s+—\s+Sold out\s*$/i,'').trim()
      : '';
    const response=await fetch(rootUrl(`products/${encodeURIComponent(handle)}.js?_fog_variant=${Date.now()}`),{
      headers:{Accept:'application/json'},
      credentials:'include',
      cache:'no-store'
    });
    const product=await response.json();
    if(!response.ok) throw new Error('Product options could not be loaded. Please refresh and try again.');
    const variants=Array.isArray(product.variants)?product.variants:[];
    let selected=selectedText
      ? variants.find((item)=>String(item.title||'').trim()===selectedText)
      : null;
    selected=selected||variants.find((item)=>item.available)||variants[0];
    id=String((selected&&selected.id)||'').trim();
    if(!/^\d+$/.test(id)) throw new Error('Please select an available product option.');
    if(variant){
      variant.value=id;
      variant.setAttribute('value',id);
    }
    return id;
  }

  function initGallery(root){
    if (root.dataset.fogGalleryBound === 'true') return;
    root.dataset.fogGalleryBound = 'true';
    const thumbs=[...root.querySelectorAll('[data-fog-thumb]')];
    const media=[...root.querySelectorAll('[data-fog-media]')];
    thumbs.forEach((thumb,index)=>{
      thumb.addEventListener('click',()=>{
        thumbs.forEach(t=>t.setAttribute('aria-current','false'));
        media.forEach(m=>{
          m.classList.remove('is-active');
          m.setAttribute('aria-hidden','true');
          const video=m.querySelector('video');
          if(video) video.pause();
        });
        thumb.setAttribute('aria-current','true');
        if(media[index]){
          media[index].classList.add('is-active');
          media[index].setAttribute('aria-hidden','false');
        }
      });
    });
  }

  function initProductForm(root){
    const form=root.querySelector('.fog-product-form');
    const sticky=root.querySelector('[data-fog-sticky-add]');
    if(!form) return;
    if(form.dataset.fogBound === 'true') return;
    form.dataset.fogBound = 'true';
    const add=form.querySelector('[type="submit"]');
    const original=add ? add.textContent : '';
    let inFlight=false;
    form.addEventListener('submit',async(e)=>{
      e.preventDefault();
      if(!add || inFlight) return;
      const variant=form.querySelector('[name="id"]');
      const quantity=form.querySelector('[name="quantity"]');
      const sellingPlan=form.querySelector('[name="selling_plan"]:not(:disabled)');
      const sellingPlanId=sellingPlan && sellingPlan.value ? sellingPlan.value : null;
      if(!variant) return;
      inFlight=true;
      add.disabled=true; add.textContent='ADDING…';
      try{
        const variantId=await resolveVariantId(variant);
        if(window.FOGCart && typeof window.FOGCart.addVariant==='function'){
          await window.FOGCart.addVariant({variantId,quantity:quantity ? quantity.value : 1,sellingPlanId,trigger:add});
        }else{
          const item={id:variantId,quantity:Math.max(1,Number(quantity ? quantity.value : 1)||1)};
          if(sellingPlanId) item.selling_plan=String(sellingPlanId);
          const response=await fetch(rootUrl('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'include',cache:'no-store',body:JSON.stringify({items:[item]})});
          const data=await response.json();
          if(!response.ok) throw new Error(data.description||'Unable to add product.');
          window.location.href=rootUrl('cart');
        }
      }catch(error){
        const message=error&&error.message?error.message:'Unable to add product.';
        if(window.FOGCart && typeof window.FOGCart.open==='function'){
          const drawerMessage=document.getElementById('fog-cart-message');
          if(drawerMessage) drawerMessage.textContent=message;
          window.FOGCart.open(add);
        }else{
          alert(message);
        }
      }finally{
        inFlight=false;
        add.disabled=false;
        add.textContent=original;
      }
    });
    if(sticky && sticky.dataset.fogBound !== 'true'){
      sticky.dataset.fogBound = 'true';
      sticky.addEventListener('click',()=>{ if(!inFlight) form.requestSubmit ? form.requestSubmit(add) : add.click(); });
    }
  }

  function initAll(){
    document.querySelectorAll('[data-fog-product-root]').forEach(root=>{initGallery(root);initProductForm(root)});
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load',initAll);
})();